<script lang="ts">
import { defineComponent, PropType, ref, watch, onMounted } from 'vue'
import type { Ref } from 'vue'

export default defineComponent({
  name: 'CheckboxDefault',

  props: {
    /**
     * 初期選択状態が bind される value
     */
    modelValue: {
      type: Array as PropType<MultiSelect>,
      default: () => [],
    },

    /**
     * フォームの name 属性
     */
    name: {
      type: String,
      default: '',
    },

    /**
     * 選択肢の項目情報
     */
    items: {
      type: Array as PropType<SelectItem[]>,
      required: true,
    },

    /**
     * 何列表示か
     */
    cols: {
      type: Number as PropType<1 | 2 | 3 | 4 | 5 | 6>,
      default: 3,
    },

    /**
     * disabled 属性にわたす非活性フラグ
     */
    isDisabled: {
      type: Boolean,
      default: false,
    },

    /**
     * エラー発生状態かどうか
     * ※ エラー状態は外から受け取る
     */
    isError: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['update:modelValue'],

  setup(props) {
    const localValue: Ref<MultiSelect> = ref([])

    watch(() => props.modelValue, (newValue) => {
      if (localValue.value !== newValue) localValue.value = newValue
    })

    onMounted(() => {
      localValue.value = props.modelValue
    })

    return {
      // data
      localValue,
    }
  }
})
</script>

<template>
  <div
    v-if="items"
    :class="[
      'o-list__cols',
      `is-col${cols}`,
    ]">
    <ul class="o-list__cols--items">
      <li
        v-for="item in items"
        :key="item.label"
        class="o-list__cols--item">
        <label
          class="label"
          :data-is-disabled="isDisabled"
          :data-is-error="isError">
          <input
            v-model="localValue"
            class="input"
            type="checkbox"
            :name="name ? `${name}[]` : undefined"
            :value="item.value"
            :disabled="isDisabled"
            :data-is-error="isError"
            @change="$emit('update:modelValue', localValue)">{{ item.label }}
        </label>
      </li>
    </ul>
  <!-- /.o-list__cols --></div>
</template>

<style lang="sass" scoped>
.label
  // normalize のチェックボックスを基準としているので、具体的な変数の値は normalize（≒ mixins.sass の checkboxStyle）を参照
  $icon-size-px: 22
  $icon-size-em: math.div($icon-size-px, $font-normal-px)
  $margin-size: 0.5em
  display: inline-block
  padding-left: ($icon-size-em + $margin-size)

  .input[type=checkbox]
    margin-left: -#{$icon-size-em + $margin-size}
</style>
